import * as runtime from '@/api/runtime'

import {
  BatchStatisticsMonthlyOutputRequest,
  BatchStatisticsMonthlyOutputRequestToJSON
} from '@/api/models/batch/BatchStatisticsMonthlyOutputConditionListItem'

export class BatchStatisticsMonthlyOutputApi extends runtime.BaseAPI {
  /**
   * 統計実行
   * @param request
   */
  async createStatisticsMonthlyOutput(
    request: BatchStatisticsMonthlyOutputRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/statistics/monthly-output`,
      BatchStatisticsMonthlyOutputRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
